import Route from 'cio/routes/base';

import CollectionModel from 'cio/models/collection';

export default class CollectionIndexRoute extends Route {
  redirect() {
    let collection = this.modelFor('collections.collection') as CollectionModel;

    if (collection.importError && collection.rows === 0) {
      this.router.replaceWith('collections');
    } else {
      this.router.replaceWith(`collections.collection.${collection.importing ? 'importing' : 'data'}`);
    }
  }
}
